import styled from 'styled-components'

import { Button } from '../components/button'
import { Text } from '../components/text'

export function NeedUpdate() {
  return (
    <Wrap>
      <Content>
        <Text size={18} weight={600} $textAlign="center">
          업데이트
        </Text>
        <Text
          size={14}
          weight={500}
          color="text_secondary"
          $textAlign="center"
          lineHeight={20}
          style={{ marginTop: '16px' }}
        >
          안정적인 서비스 사용을 위해서
          <br />
          업데이트 이후 사용해 주세요.
        </Text>
        {window.navigator.userAgent.match(/iPhone/gi) && (
          <div
            style={{
              display: 'flex',
              gap: '8px',
              marginTop: '24px',
            }}
          >
            <a href="https://abr.ge/63337q" style={{ display: 'block', width: '100%' }}>
              <Button type="primary" block={true}>
                업데이트
              </Button>
            </a>
          </div>
        )}
      </Content>
    </Wrap>
  )
}

const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100vw;
  height: 100vh;
  background-color: rgba(28, 34, 39, 0.6);
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 50%;
  left: 50%;
  width: calc(100% - 32px - 32px);
  min-width: 290px;
  maxwidth: 330px;
  padding: 24px 16px 16px;
  border-radius: 8px;
  background-color: #ffffff;
  transform: translate(-50%, -50%);
`
